import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../hooks/hooks";
import { dataSearchStatus } from "../../../store/dataSearchSlice";
import { useLoader } from "../../../hooks/common/useLoader";
import { ListTable } from "../../../layout/content/list/ListTable";
import excelIcon from "../../../assets/images/button_icons/excel_icon.svg";
import { useDataSearchFilters } from "../hooks/useDataSearchFilters";
import { useTestResultWideColumns } from "../hooks/useTestResultWideColumns";
import { useTestResultWideList } from "../hooks/useTestResultWideList";
import { useTestResultWideDownloader } from "../hooks/useTestResultWideDownloader";
import { TestResultSearchCondition } from "../../../types/dataSearch";

export function TestResultWideSearch() {
  const { t } = useTranslation("dataSearch");
  const status = useAppSelector(dataSearchStatus);

  useLoader({ status });

  const { searchTestResultWideList, totalCnt, testResultWideList, columnKeys, pageCondition, getSearchParam } =
    useTestResultWideList({});
  const { filters } = useDataSearchFilters({ search: searchTestResultWideList({}) });
  const { columns } = useTestResultWideColumns(columnKeys);
  const { downloadTestResultWide } = useTestResultWideDownloader();

  const onClickDownload = useCallback(() => {
    const condition = {
      ...(getSearchParam() as unknown as TestResultSearchCondition),
    };
    downloadTestResultWide(condition);
  }, [downloadTestResultWide, getSearchParam]);

  return (
    <>
      {testResultWideList ? (
        <div style={{ overflowX: "auto" }}>
          <ListTable
            pageOnFilter={pageCondition}
            filters={filters}
            totalRowsCnt={{
              totalCount: <span>{t("list.totalLabel", { count: totalCnt ?? 0 })}</span>,
              singleUnitKeyInCommonFile: "testHistoryUnit.singleComponent",
              multipleUnitKeyInCommonFile: "testHistoryUnit.multipleComponent",
            }}
            columns={columns}
            listData={testResultWideList}
            getList={({ page, sort, size }) => searchTestResultWideList({ page, sort, size })}
            buttonsNode={
              <>
                <div></div>
                <div>
                  <button onClick={onClickDownload}>
                    <img src={excelIcon} alt={t("list.downloadExcel.iconAlt")} />
                    {t("list.downloadExcel.buttonLabel")}
                  </button>
                </div>
              </>
            }
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
